webpackJsonp([131539946758196],{

/***/ 1563:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/tutoring/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-tutoring-18b6fecd5bf8f48ed6c7.js